<template>
  <div class="resourceLedgerAdd">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="returnList()">{{$t('lang.resourBack')}}</el-button>
      </div>
      <el-form :rules="rules" ref="ruleForm" :model="ruleForm" :label-width="require('@/config/enum').c_ws6"
        :label-suffix="require('@/config/enum').c_colon" :inline="true" class="demo-form-inline form">
        <el-form-item :label="$t('lang.resourProName')" prop="entryName">
          <el-input maxlength="50" v-model="ruleForm.entryName" :placeholder="$t('lang.resourWriteProName')"
            class="input"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.resourProNum')" prop="entryNumber">
          <el-input maxlength="50" v-model="ruleForm.entryNumber" :placeholder="$t('lang.resourWriteProNum')"
            class="input"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.resourPointName')" prop="placeName">
          <el-input maxlength="50" v-model="ruleForm.placeName" :placeholder="$t('lang.resourWritePointName')"
            class="input"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.resourPointNum')" prop="placeNumber">
          <el-input maxlength="50" v-model="ruleForm.placeNumber" :placeholder="$t('lang.resourWritePointNum')"
            class="input"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.resourPointAttr')" prop='pointAttr'>
          <el-select class="input" v-model="ruleForm.pointAttr" :placeholder="$t('lang.resourWritePointAttr')">
            <el-option v-for="item in ruleForm.pointAttrList" :key="item.id" :label="item.code" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('lang.resourOneClassify')" prop='firstsort'>
          <el-select class="input" @change="getSeleList('twoResourceType' + ruleForm.firstsort)"
            v-model="ruleForm.firstsort" :placeholder="$t('lang.resourWriteOneClassify')">
            <el-option v-for="item in ruleForm.firstsortlist" :key="item.id" :label="item.code" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.resourTwoClassify')" prop='secondsort'>
          <el-select class="input" v-model="ruleForm.secondsort" :placeholder="$t('lang.resourWriteTwoClassify')">
            <el-option key :label="$t('lang.lab_pleSelsecondsort')" value="0" v-show="this.ruleForm.firstsort === '0'">
            </el-option>
            <el-option v-for="item in ruleForm.secondsortlist" :key="item.id" :label="item.code" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('lang.resourBuild')" prop="storBuild">
          <el-input maxlength="50" v-model="ruleForm.storBuild" :placeholder="$t('lang.resourWriteBuild')"
            class="input"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.resourUnit')" prop="unit">
          <el-input maxlength="50" v-model="ruleForm.unit" :placeholder="$t('lang.resourWriteUnit')" class="input">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.resourAdress')" prop="adress">
          <el-input maxlength="50" v-model="ruleForm.adress" :placeholder="$t('lang.resourWriteAdress')" class="input">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.resourStatus')" prop='state'>
          <el-select class="input" v-model="ruleForm.state" placeholder="">
            <el-option v-for="item in ruleForm.stateList" :key="item.id" :label="item.code" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item :label="$t('lang.resourRemark')" prop='remark'>
          <el-input maxlength="500" rows="5" cols="158" type="textarea" v-model="ruleForm.remark"
            :placeholder="$t('lang.resourWriteRemark')"></el-input>
        </el-form-item>
        <el-divider></el-divider>
        <el-form-item  :label="$t('lang.lab_image')" prop="imageUri"  ref="imageUri">
          <upload-file ref="uploading" :accept='accept'  upTypes='1' :fileList='fileList' :clears='clears' @outputFile="getFile" @removeFile='removeFile'></upload-file>
        </el-form-item>
        <el-form-item class="blockBox">
          <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
          <el-button class="detailbtn" type="primary" :disabled='isCanUse' @click="onSubmit('ruleForm')">
            {{$t('lang.btn_save')}}
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:resourceLedgerAdd
   *@Description:资源台账添加
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-04-20
   */
  import UploadFile from '../../../components/upload_file.vue'
  export default {
    data() {
      var PointAttr = (rule, value, callback) => {
        if (value == 0) {
          return callback(new Error(this.$i18n.t('lang.resourWritePointAttr')))
        } else {
          callback()
        }
      }
      var OneClassify = (rule, value, callback) => {
        if (value == 0) {
          return callback(new Error(this.$i18n.t('lang.resourWriteOneClassify')))
        } else {
          callback()
        }
      }
      var TwoClassify = (rule, value, callback) => {
        if (value == 0) {
          return callback(new Error(this.$i18n.t('lang.resourWriteTwoClassify')))
        } else {
          callback()
        }
      }
      var Status = (rule, value, callback) => {
        if (value == 0) {
          return callback(new Error(this.$i18n.t('lang.resourWriteStatus')))
        } else {
          callback()
        }
      }
      return {
        accept: '.jpg, .jpeg, .png',
        fileList: [], // 图片上传
        clears: false, // 清空按钮
        saveData: {
          entryName: '', // 项目名称
          entryNumber: '', // 项目编号
          placeName: '', // 点位名称
          placeNumber: '', // 点位编号
          pointAttr: '0', // 点位属性
          pointAttrList: [], // 点位属性列表
          firstsort: '0', // 一级分类
          firstsortlist: [], // 一级分类列表
          secondsort: '0', // 二级分类
          secondsortlist: [], // 二级分类列表
          state: '0', // 选择状态
          stateList: [], // 状态列表
          storBuild: '', // 楼栋
          unit: '', // 单元
          adress: '', // 位置
          remark: '', // 备注
          imageUri: '', // 图片链接
        },
        id: '', // 台账id
        isCanUse: false, // 保存按钮可用状态
        changeIt: '', // 添加是1   编辑是0
        ruleForm: {
          entryName: '', // 项目名称
          entryNumber: '', // 项目编号
          placeName: '', // 点位名称
          placeNumber: '', // 点位编号
          pointAttr: '0', // 点位属性
          pointAttrList: [], // 点位属性列表
          firstsort: '0', // 一级分类
          firstsortlist: [], // 一级分类列表
          secondsort: '0', // 二级分类
          secondsortlist: [], // 二级分类列表
          state: '0', // 选择状态
          stateList: [], // 状态列表
          storBuild: '', // 楼栋
          unit: '', // 单元
          adress: '', // 位置
          remark: '', // 备注
          imageUri: '', // 图片链接
          fileList: [], // 上传文件集合
        },
        rules: {
          entryName: [{
            required: true,
            message: this.$i18n.t('lang.resourWriteProName'),
            trigger: 'blur'
          }],
          entryNumber: [{
            required: true,
            message: this.$i18n.t('lang.resourWriteProNum'),
            trigger: 'blur'
          }],
          placeName: [{
            required: true,
            message: this.$i18n.t('lang.resourWritePointName'),
            trigger: 'blur'
          }],
          placeNumber: [{
            required: true,
            message: this.$i18n.t('lang.resourWritePointNum'),
            trigger: 'blur'
          }],
          pointAttr: [{
            required: true,
            message: this.$i18n.t('lang.resourWritePointAttr'),
            validator: PointAttr,
            trigger: 'change'
          }],
          firstsort: [{
            required: true,
            message: this.$i18n.t('lang.resourWriteOneClassify'),
            validator: OneClassify,
            trigger: 'change'
          }],
          secondsort: [{
            required: true,
            message: this.$i18n.t('lang.resourWriteTwoClassify'),
            validator: TwoClassify,
            trigger: 'change'
          }],
          storBuild: [{
            required: true,
            message: this.$i18n.t('lang.resourWriteBuild'),
            trigger: 'blur'
          }],
          unit: [{
            required: true,
            message: this.$i18n.t('lang.resourWriteUnit'),
            trigger: 'blur'
          }],
          adress: [{
            required: true,
            message: this.$i18n.t('lang.resourWriteAdress'),
            trigger: 'blur'
          }],
          state: [{
            required: true,
            message: this.$i18n.t('lang.resourWriteStatus'),
            validator: Status,
            trigger: 'change'
          }],
       }
      }
    },
      components: {
      'upload-file': UploadFile
      },
    destroyed() {
      window.localStorage.setItem('resourceLedgerAddform', JSON.stringify(this.ruleForm))
      window.localStorage.setItem('resourceLedgerAddsaveData', JSON.stringify(this.saveData))
    },
    created() {
      // 获取下拉的列表
      this.getSeleList('oneResourceType')
      this.getSeleList('resourceState')
      this.getSeleList('pointPositionAttr')
      // 获取台账id 有id是编辑  没有id是添加
      this.id = this.$route.query.Id
      if (window.localStorage.getItem('resourceLedgerAddform')) {
      this.ruleForm = JSON.parse(window.localStorage.getItem('resourceLedgerAddform'))
      if (this.ruleForm.imageUri) {
         this.fileList.push({
            name: '',
            url: this.ruleForm.imageUri
          })
      }
       if (window.localStorage.getItem('resourceLedgerAddsaveData')) {
        this.saveData = JSON.parse(window.localStorage.getItem('resourceLedgerAddsaveData'))
       }
    } else {
      if (this.id) {
        // 调用详情方法
        this.getPageData()
        // 编辑
        this.changeIt = 0
      } else {
        // 添加
        this.changeIt = 1
      }
    }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          if (this.changeIt == 0) {
            if (JSON.stringify(newVal) == JSON.stringify(this.saveData)) {
              this.isCanUse = true
            } else {
              this.isCanUse = false
            }
          } else {
             this.isCanUse = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
    // 获取组件值
    getFile(e) {
      this.ruleForm.imageUri = e
      this.$refs.imageUri.clearValidate()
    },
    // 移除图片
    removeFile(e) {
      this.fileList = []
      this.ruleForm.imageUri = ''
    },
      handleChange(value) {
        console.log(value)
      },
      // 返回列表页
      returnList() {
        this.$router.push({
          name: 'resourceLedgerList'
        })
      },
      // 页面全部下拉列表方法
      getSeleList(code) {
        let loading = this.$loading()
        this.$get(`/getValueListByCode?code=${code}`).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (code === 'oneResourceType') {
                // 一级分类列表
                this.ruleForm.firstsortlist = res.result
                this.saveData.firstsortlist = res.result
                console.log(res.result)
              } else if (code === 'resourceState') {
                // 状态列表
                this.ruleForm.stateList = res.result
                this.saveData.stateList = res.result
              } else if (code === 'pointPositionAttr') {
                // 点位属性列表
                this.ruleForm.pointAttrList = res.result
                this.saveData.pointAttrList = res.result
              } else {
                // 二级分类列表
                this.ruleForm.secondsortlist = res.result
                this.ruleForm.secondsort = '0'
                if (code === 'twoResourceType0') {
                  this.ruleForm.secondsortlist = []
                  this.ruleForm.secondsort = '0'
                }
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 详情方法
      getPageData() {
        let loading = this.$loading()
        this.$get(`/getResourceLedgerById?Id=` + this.id).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.ruleForm.entryName = res.result.ItemName // 项目名称
              this.ruleForm.entryNumber = res.result.ItemNo // 项目编号
              this.ruleForm.placeName = res.result.PointPositionName // 点位名称
              this.ruleForm.placeNumber = res.result.PointPositionNo // 点位编号
              this.ruleForm.pointAttr = res.result.PointPositionAttr // 点位属性
              this.ruleForm.firstsort = res.result.OneResourceType // 一级分类
              this.ruleForm.secondsort = res.result.TwoResourceType // 二级分类
              this.ruleForm.state = res.result.State.toString() // 选择状态
              this.ruleForm.storBuild = res.result.House // 楼栋
              this.ruleForm.unit = res.result.Unit // 单元
              this.ruleForm.adress = res.result.Position // 位置
              this.ruleForm.remark = res.result.Remark // 备注

              this.saveData.entryName = res.result.ItemName // 项目名称
              this.saveData.entryNumber = res.result.ItemNo // 项目编号
              this.saveData.placeName = res.result.PointPositionName // 点位名称
              this.saveData.placeNumber = res.result.PointPositionNo // 点位编号
              this.saveData.pointAttr = res.result.PointPositionAttr // 点位属性
              this.saveData.firstsort = res.result.OneResourceType // 一级分类
              this.saveData.secondsort = res.result.TwoResourceType // 二级分类
              this.saveData.state = res.result.State.toString() // 选择状态
              this.saveData.storBuild = res.result.House // 楼栋
              this.saveData.unit = res.result.Unit // 单元
              this.saveData.adress = res.result.Position // 位置
              this.saveData.remark = res.result.Remark // 备注
              if (res.result.imgUri[0]) {
                this.fileList.push({
                name: '',
                url: res.result.imgUri[0].Uri
                })
                this.ruleForm.imageUri = res.result.imgUri[0].Uri
              } else {
                this.ruleForm.imageUri = ''
              }
              this.$get(`/getValueListByCode?code=twoResourceType` + res.result.OneResourceType).then(res => {
                this.ruleForm.secondsortlist = res.result
                this.saveData.secondsortlist = res.result
              })
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 保存方法
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.changeIt == 1) {
              // 添加向后台传的参数
              let params = {
                ItemName: this.ruleForm.entryName,
                ItemNo: this.ruleForm.entryNumber,
                PointPositionName: this.ruleForm.placeName,
                PointPositionNo: this.ruleForm.placeNumber,
                PointPositionAttr: this.ruleForm.pointAttr,
                OneResourceType: this.ruleForm.firstsort,
                TwoResourceType: this.ruleForm.secondsort,
                House: this.ruleForm.storBuild,
                Unit: this.ruleForm.unit,
                Position: this.ruleForm.adress,
                State: this.ruleForm.state,
                Remark: this.ruleForm.remark,
                ImgUri: this.ruleForm.imageUri,
              }
              this.$post('/AOEResourceLedger', params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.resourAddSuccess')
                  })
                  var index = this.$keepAlive.indexOf('/manage/main.resourceLedgerList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({
                    name: 'resourceLedgerList'
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.resourAddLose')
                  })
                }
              })
            } else if (this.changeIt == 0) {
              // 添加向后台传的参数
              let params = {
                Id: this.id,
                ItemName: this.ruleForm.entryName,
                ItemNo: this.ruleForm.entryNumber,
                PointPositionName: this.ruleForm.placeName,
                PointPositionNo: this.ruleForm.placeNumber,
                PointPositionAttr: this.ruleForm.pointAttr,
                OneResourceType: this.ruleForm.firstsort,
                TwoResourceType: this.ruleForm.secondsort,
                House: this.ruleForm.storBuild,
                Unit: this.ruleForm.unit,
                Position: this.ruleForm.adress,
                State: this.ruleForm.state,
                Remark: this.ruleForm.remark,
                ImgUri: this.ruleForm.imageUri,
              }
              this.$post('/AOEResourceLedger', params).then(res => {
                if (res.errCode == 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.resourEditSuccess')
                  })
                  var index = this.$keepAlive.indexOf('/manage/main.resourceLedgerList')
                  if (index > -1) {
                    this.$keepAlive.splice(index, 1)
                  }
                  this.$router.push({
                    name: 'resourceLedgerList'
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.resourEditLose')
                  })
                }
              })
            }
          }
        })
      },
      // 清空方法
      resetForm(formName) {
       this.clears = true
       this.$refs.ruleForm.clearValidate()
        // this.ruleForm.entryName = '' // 项目名称
        // this.ruleForm.entryNumber = '' // 项目编号
        // this.ruleForm.placeName = '' // 点位名称
        // this.ruleForm.placeNumber = '' // 点位编号
        // this.ruleForm.pointAttr = '0' // 点位属性
        // this.ruleForm.pointAttrList = [] // 点位属性列表
        // this.ruleForm.firstsort = '0' // 一级分类
        // this.ruleForm.firstsortlist = [] // 一级分类列表
        // this.ruleForm.secondsort = '0' // 二级分类
        // this.ruleForm.secondsortlist = [] // 二级分类列表
        // this.ruleForm.state = '0' // 选择状态
        // this.ruleForm.stateList = [] // 状态列表
        // this.ruleForm.storBuild = '' // 楼栋
        // this.ruleForm.unit = '' // 单元
        // this.ruleForm.adress = '' // 位置
        // this.ruleForm.remark = '' // 备注
        // this.ruleForm.imageUri = '' // 图片链接
        // this.ruleForm.fileList = [] // 上传文件集合
      },
    }
  }
</script>

<style lang="scss">
  .resourceLedgerAdd {
    .input {
      width: 500px;
    }
    .blockBox {
      display: block;
    }
  }
</style>